<template lang="pug">
  y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
    v-card
      v-card-title.px-4.h6.basic800--text {{ $t('new_label') }}
      v-divider.basic300
      v-card-text.pa-4
        v-form(ref="form")
          div.label.basic600--text.text-uppercase {{ $t('label_name') }}
          v-text-field.mt-2(v-model="customLabel.text" :placeholder="$t('label_placeholder')" background-color="basic200" height="40" outlined dense hide-details="auto" :rules="rules.not_empty")
          div.label.basic600--text.text-uppercase.pt-4 {{ $t('label_color') }}
          v-color-picker.mt-2(v-model="customLabel.color" mode="hexa" show-swatches swatches-max-height="150" hide-canvas hide-inputs)
        
      v-card-actions.px-4.pb-4.pt-0
        v-spacer
        v-btn(color="white" text height=32 @click="closeModal")
          .button-Aa-small.primary400--text {{ $t('cancel') }}
        v-btn(color='info500' depressed height=32 :loading="isLoading" @click="clickSave" dark)
          .button-AA-small.basic100--text {{ $t('save') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'AddLabel',
  props: ['open', 'selectedLabel'],
  data: () => ({
    isLoading: false,
    customLabel: {
      color: '#000000'
    },
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    },
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
    if (this.selectedLabel) {
      this.customLabel = { ...this.selectedLabel.properties }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      if (this.selectedLabel) {
        this.$axios.patch(`/lead_customlabels/${this.selectedLabel.id}`, { properties: this.customLabel })
          .then(resp => {
            this.$emit('edit', resp.data)
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      } else {
        this.$axios.post('/lead_customlabels', { company: this.company.id, properties: this.customLabel })
          .then(resp => {
            this.$emit('add', resp.data)
            this.showModal = false
          })
          .catch(() => {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          })
          .finally(() => {
            this.isLoading = false
          })
      }
    },
    closeModal () {
      if (this.selectedLabel) {
        this.$emit('close')
      }
      this.showModal = false
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "new_label": "New label",
    "label_name": "Label name",
    "label_color": "Label color",
    "label_placeholder": "Write label name here"
  },
  "id": {
    "new_label": "Label baru",
    "label_name": "Nama label",
    "label_color": "Warna label",
    "label_placeholder": "Tulis nama label di sini"
  }
}
</i18n>